export default __webpack_public_path__ + "static/media/rate-partner.e769c433.png";